import script from "./DocumentsChart.vue?vue&type=script&setup=true&lang=ts"
export * from "./DocumentsChart.vue?vue&type=script&setup=true&lang=ts"

import "./DocumentsChart.vue?vue&type=style&index=0&id=221c329b&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-221c329b"]])

export default __exports__